import * as types from './constants';

// Get Unmasking Invitations
export const getUnmaskingInvitationsRequest = data => (
  { type: types.GET_UNMASKING_INVITATIONS_REQUEST, payload: data }
);

export const getUnmaskingInvitationsDone = data => (
  { type: types.GET_UNMASKING_INVITATIONS_DONE, payload: data }
);

export const getUnmaskingInvitationsFailed = errors => (
  { type: types.GET_UNMASKING_INVITATIONS_FAILED, payload: errors }
);

// Operations
export const unmaskingInvitationsSetPage = data => (
  { type: types.UNMASKING_INVITATIONS_SET_PAGE, payload: data }
);